import React from "react";
import { useSpring, animated } from "react-spring";
import { Link } from "react-router-dom";

function Home() {
  const fadeAnimation1 = useSpring({ opacity: 1, from: { opacity: 0 } });
  const fadeAnimation2 = useSpring({
    opacity: 1,
    from: { opacity: 0 },
    delay: 600,
  });
  const fadeAnimation3 = useSpring({
    opacity: 1,
    from: { opacity: 0 },
    delay: 1200,
  });
  const buttonAnimation = useSpring({
    opacity: 1,
    from: { opacity: 0 },
    delay: 1700,
  });

  const slideAnimation1 = useSpring({
    from: { transform: "translateY(-50px)", opacity: 0 },
    to: { transform: "translateY(0)", opacity: 1 },
    config: { duration: 800 },
  });

  const slideAnimation2 = useSpring({
    from: { transform: "translateY(-50px)", opacity: 0 },
    to: { transform: "translateY(0)", opacity: 1 },
    delay: 600,
    config: { duration: 800 },
  });

  const slideAnimation3 = useSpring({
    from: { transform: "translateY(-50px)", opacity: 0 },
    to: { transform: "translateY(0)", opacity: 1 },
    delay: 1200,
    config: { duration: 800 },
  });

  return (
    <div>
      <animated.h1 style={slideAnimation1}>
        Power your <span style={{ opacity: fadeAnimation1.opacity }}></span>
        <animated.span
          className="orangeFixed"
          style={{ opacity: fadeAnimation1.opacity }}
        >
          cybersecurity
        </animated.span>
      </animated.h1>
      <animated.h2 style={slideAnimation2}>
        Meet your new AI security advisor
      </animated.h2>
      <div className="center-text">
        <animated.p style={slideAnimation3}>
          Empower your code's security with our app—a comprehensive solution
          that scans for vulnerabilities, aids in fixing them, and provides
          detailed reports for peace of mind.
        </animated.p>
      </div>
      <animated.div className="button-container" style={buttonAnimation}>
        <div className="center">
          <Link to="/AboutUs">
            <animated.button
              className="btn btn-primary button orangeBtn"
              style={buttonAnimation}
            >
              About us
            </animated.button>
          </Link>
        </div>
        <div className="center">
          <Link to="/Analyzer">
            <animated.button
              className="btn btn-primary button"
              style={buttonAnimation}
            >
              Try scan
            </animated.button>
          </Link>
        </div>
      </animated.div>
    </div>
  );
}

export default Home;
